import { FlowComponentHeader } from "@/components/ui/flow-component-header";
import { useInstancePortfolioCosts } from "@/lib/hooks/use-flow-instances/use-cost-overrides";
import { useT } from "@/lib/i18n/use-t";
import { PortfolioCostsWidget } from "@/pages/clients/detail/flows/instance/portfolio-costs-widget";
import { T } from "./portfolio-costs-renderer.i18n";
import type { PortfolioCostsConfig, PortfolioCostsRendererProps } from "./types";

export function PortfolioCostsRenderer({
  component,
  portfolioCosts: definitionCosts,
  flowInstanceId = null,
  flowCurrency,
}: PortfolioCostsRendererProps) {
  const t = useT(T);
  // QL-20 — the instance's fee rows: an overridden fee shows the catalogue value struck through.
  const { portfolioCosts: instanceCosts } = useInstancePortfolioCosts(flowInstanceId);
  const portfolioCosts = instanceCosts ?? definitionCosts;

  if (portfolioCosts.length === 0) {
    return (
      <div className="text-sm text-muted-foreground p-4 border border-dashed rounded-lg">
        {t.noPortfolioCosts}
      </div>
    );
  }

  let portfolioCostsConfig: PortfolioCostsConfig = {};
  try {
    portfolioCostsConfig = component.config ? JSON.parse(component.config) : {};
  } catch {
    // Invalid config
  }

  const getContainerClass = () => {
    if (portfolioCostsConfig.style === "border") return "border rounded-lg p-4";
    if (portfolioCostsConfig.style === "box") return "bg-muted/30 rounded-lg p-4";
    return "";
  };

  return (
    <div className={`w-full ${getContainerClass()}`}>
      <FlowComponentHeader
        title={portfolioCostsConfig.title}
        description={portfolioCostsConfig.description}
        className="mb-4"
      />
      <PortfolioCostsWidget portfolioCosts={portfolioCosts} currency={flowCurrency} />
    </div>
  );
}
